var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._b({ref:"fileInput",attrs:{"type":"file"},on:{"change":_vm.handleFileChange}},'input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }